// FETCH PROGRAMS SESSIONS BY SESSION ID
export const FETCH_PROGRAM_SESSION_BY_ID = {
  request: 'FETCH_PROGRAM_SESSION_BY_ID_REQUEST',
  success: 'FETCH_PROGRAM_SESSION_BY_ID_SUCCESS',
  failure: 'FETCH_PROGRAM_SESSION_BY_ID_FAILURE',
};

export const requestFetchProgramSessionById = (payload) => ({
  type: FETCH_PROGRAM_SESSION_BY_ID.request,
  payload,
});

export const receiveFetchProgramSessionById = (payload) => ({
  type: FETCH_PROGRAM_SESSION_BY_ID.success,
  payload,
});

export const failureFetchProgramSessionById = (payload) => ({
  type: FETCH_PROGRAM_SESSION_BY_ID.failure,
  payload,
});

export const FETCH_EXPANDED_SESSION_INFO = {
  request: 'FETCH_EXPANDED_SESSION_INFO_REQUEST',
  success: 'FETCH_EXPANDED_SESSION_INFO_SUCCESS',
  failure: 'FETCH_EXPANDED_SESSION_INFO_FAILURE',
};

export const requestFetchExpandedSessionInfo = (payload) => ({
  type: FETCH_EXPANDED_SESSION_INFO.request,
  payload,
});

export const successFetchExpandedSessionInfo = (payload) => ({
  type: FETCH_EXPANDED_SESSION_INFO.success,
  payload,
});

export const failureFetchExpandedSessionInfo = (payload) => ({
  type: FETCH_EXPANDED_SESSION_INFO.failure,
  payload,
});
